<div>
  <google-map
    *ngIf="defaultConfig.coordinates"
    class="advanced_map"
    height="100%"
    width="100%"
    [options]="mapOptions"
    [zoom]="defaultConfig.zoom"
    [center]="{
      lat: defaultConfig.coordinates.latitude!,
      lng: defaultConfig.coordinates.longitude!
    }"
  >
  </google-map>

  <!-- Network Assets Overview -->
  <ng-container *ngIf="!selectedAsset; else assetSelected">
    <div
      class="overview"
      [ngClass]="{
        'negative-top-margin': isFromAdvancedMap || isFromLegacyMap
      }"
    >
      <div class="select-row">
        <ng-container *ngTemplateOutlet="assetFilter"></ng-container>
        <div class="divider"></div>
        <ng-container *ngTemplateOutlet="selectTemplate"></ng-container>
      </div>
    </div>
  </ng-container>

  <!-- Overview if Asset Selected -->
  <ng-template #assetSelected>
    <div class="overview">
      <div class="select-row">
        <ng-container *ngTemplateOutlet="assetFilter"></ng-container>
        <div class="divider"></div>
        <ng-container *ngTemplateOutlet="selectTemplate"></ng-container>
      </div>
    </div>
  </ng-template>

  <!-- Asset Filter Template -->
  <ng-template #assetFilter>
    <div class="assetFilter">
      <app-single-select-dropdown2
        id="asset-filter"
        [items]="assetTypeItems"
        [searchFilterActive]="false"
        [label]="'NETWORK_ASSET.ALL_ASSETS'"
        [showMore]="false"
        [selectedItem]="selectedAssetFilterItem"
        [textColor]="'black'"
        (shareSelectedItem)="onAssetFilterSelected($event)"
      >
      </app-single-select-dropdown2>
    </div>
  </ng-template>

  <!-- TEMPLATE -->
  <ng-template #selectTemplate>
    <app-single-select-dropdown2
      id="selectTemplate"
      class="multiselect"
      [clicked]="clicked"
      [items]="selectedAssetOptions"
      [searchFilterActive]="true"
      [label]="'Select asset to start'"
      [showMore]="false"
      [disabled]="selectedAsset === null"
      [selectedItem]="selectedItem"
      (shareSelectedItem)="handleSelectedItem($event)"
      (filterValue)="applySearchFilter($event)"
      (applyFilterEmitter)="applyFilter($event)"
    >
    </app-single-select-dropdown2>
  </ng-template>

  <div class="asset-cards" *ngIf="!selectedAsset">
    <div class="row asset-card-row" *ngFor="let asset of assetList">
      <div
        class="col-4 asset-card"
        (click)="selectAssetFromHierarchy(asset.id)"
        [ngStyle]="{ border: 'solid 3px ' + asset.borderColor }"
      >
        <img [src]="asset.svgPath" alt="{{ asset.cardName }}" />
        <div class="card-name">
          {{ "DASHBOARD.NETWORKASSET." + asset.cardName | translate }}
        </div>
        <div class="asset-count">{{ asset.count }}</div>
      </div>
    </div>
  </div>

  <app-vflow-chart
    *ngIf="nodes.length > 0"
    [nodes]="nodes"
    [edges]="edges"
  ></app-vflow-chart>

  <div *ngIf="selectedAsset && nodes.length == 0" class="no-selected-item">
    <div class="select-asset-to-start">
      <div class="text">
        {{ "NETWORK_ASSET." + assetKeys[selectedAsset - 1] | translate }}
      </div>
      <div class="asset-img">
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.5 12.5276H25.9231C26.5968 15.2496 29.059 17.2739 31.9862 17.2739C34.9133 17.2739 37.3756 15.2496 38.0493 12.5276H46.5C47.3284 12.5276 48 11.856 48 11.0276C48 10.1992 47.3284 9.52763 46.5 9.52763H38.0492C37.3756 6.80569 34.9133 4.78125 31.9861 4.78125C29.0588 4.78125 26.5966 6.80569 25.923 9.52763H1.5C0.671625 9.52763 0 10.1992 0 11.0276C0 11.856 0.671625 12.5276 1.5 12.5276ZM31.9862 7.78125C33.7762 7.78125 35.2326 9.23756 35.2326 11.0275C35.2326 12.8176 33.7762 14.2739 31.9862 14.2739C30.1961 14.2739 28.7398 12.8176 28.7398 11.0275C28.7398 9.23756 30.1961 7.78125 31.9862 7.78125ZM1.5 25.5015H9.95081C10.6245 28.2234 13.0867 30.2478 16.0139 30.2478C18.9412 30.2478 21.4033 28.2234 22.077 25.5015H46.5C47.3284 25.5015 48 24.8299 48 24.0015C48 23.1731 47.3284 22.5015 46.5 22.5015H22.0769C21.4032 19.7796 18.9411 17.7551 16.0138 17.7551C13.0866 17.7551 10.6244 19.7796 9.95072 22.5015H1.5C0.671625 22.5015 0 23.1731 0 24.0015C0 24.8299 0.671531 25.5015 1.5 25.5015ZM16.0138 20.7551C17.8039 20.7551 19.2602 22.2114 19.2602 24.0015C19.2602 25.7915 17.8039 27.2478 16.0138 27.2478C14.2237 27.2478 12.7674 25.7915 12.7674 24.0015C12.7674 22.2114 14.2237 20.7551 16.0138 20.7551ZM46.5 35.4754H38.0492C37.3755 32.7534 34.9133 30.729 31.9861 30.729C29.0588 30.729 26.5967 32.7534 25.923 35.4754H1.5C0.671625 35.4754 0 36.147 0 36.9754C0 37.8037 0.671625 38.4754 1.5 38.4754H25.9231C26.5968 41.1973 29.0589 43.2217 31.9862 43.2217C34.9134 43.2217 37.3756 41.1973 38.0493 38.4754H46.5C47.3284 38.4754 48 37.8037 48 36.9754C48 36.147 47.3285 35.4754 46.5 35.4754ZM31.9862 40.2217C30.1961 40.2217 28.7398 38.7654 28.7398 36.9754C28.7398 35.1853 30.1961 33.729 31.9862 33.729C33.7762 33.729 35.2326 35.1853 35.2326 36.9754C35.2326 38.7654 33.7762 40.2217 31.9862 40.2217Z"
            fill="#00875A"
          />
        </svg>
      </div>
    </div>
  </div>

  <app-network-assets-more-options
    *ngIf="showMore"
    [parentId]="parentId"
    [networkAssetType]="networkAssetTypes"
    [parentNetworkAssetType]="parentNetworkAssetTypes"
    [borderColor]="borderColor"
    [excludeIds]="excludeIds"
    [assetType]="modalHeader"
    (selectedIdEmiter)="reloadTree($event)"
  ></app-network-assets-more-options>
</div>
